import React from 'react'

import {
  ProfileButton,
  ProfileMenuBlock,
  ProfileTitle,
} from './ProfileComponents.tsx'
import { recurrentTermsUrl, termsUrl } from '../auth/login.tsx'
import { FormattedMessage } from 'react-intl'

const links = [
  {
    title: <FormattedMessage id="user.terms" />,
    url: recurrentTermsUrl,
  },
  {
    title: <FormattedMessage id="user.privacyPolicy" />,
    url: termsUrl,
  },
] as const

export const ProfileAbout = () => {
  return (
    <div>
      <ProfileTitle title={<FormattedMessage id="user.aboutUs" />} />
      <div className="flex flex-col gap-16">
        {links.map((x, i) => {
          return (
            <ProfileMenuBlock key={i}>
              <ProfileButton
                withArrow
                onClick={() => {
                  window.open(x.url, '_blank')
                }}
                title={x.title}
              />
            </ProfileMenuBlock>
          )
        })}
      </div>
    </div>
  )
}
